import { isLocal } from '@magicschool/utils/nextjs/metadata';
import { getLoginUrl } from '@magicschool/utils/nextjs/url';
import type { NextRequest } from 'next/server';
import { getRequestOrigin } from '@/util/getRequestOrigin';

export const edlinkLaunchUrl = () => {
  const edlinkSSOLogin = new URL('/sso/login', EDLINK_DOMAIN);
  edlinkSSOLogin.searchParams.set('client_id', process.env.NEXT_PUBLIC_EDLINK_CLIENT_ID);
  edlinkSSOLogin.searchParams.set('redirect_uri', edlinkRedirectUri());
  edlinkSSOLogin.searchParams.set('response_type', 'code');

  return edlinkSSOLogin.href;
};

export const edlinkRedirectUri = () => {
  // The Edlink widget doesn't support subdomains on localhost
  const base = isLocal() ? 'http://localhost:3000/' : getLoginUrl();
  return new URL('/handle-edlink', base).href;
};

/** OAuth redirect_uri for token exchange — must match the host Edlink redirected the browser to. */
export const edlinkRedirectUriFromRequest = (request: NextRequest): string => {
  return new URL('/handle-edlink', `${getRequestOrigin(request)}/`).href;
};

export const EDLINK_DOMAIN = 'https://ed.link';

export const getAssignmentUrl = (classId: string, assignmentId: string) => {
  return `/classes/${classId}/assignments/${assignmentId}`;
};

export const getEdlinkIntegrationUrl = (integrationId: string) => {
  return `${EDLINK_DOMAIN}/magicschool/integrations/${integrationId}`;
};
